module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.message[0]) ? _c('div', {
    staticClass: "col-md-3 col-xs-12"
  }, [(_vm.message[0].totalCollection === null) ? _c('va-small-box', {
    staticClass: "info-box box-blue",
    attrs: {
      "icon": "ion-briefcase ",
      "title": 0,
      "description": "Total Collection Amount",
      "moreText": "More info"
    },
    on: {
      "more-click": _vm.clickToSmallBox
    }
  }) : _c('va-small-box', {
    staticClass: "info-box box-blue",
    attrs: {
      "icon": "ion-briefcase ",
      "title": _vm.message[0].totalCollection,
      "description": "Total Collection Amount",
      "moreText": "More info"
    },
    on: {
      "more-click": _vm.clickToSmallBox
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-06e5963d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/dashboard/totalcollection.vue
// module id = 720
// module chunks = 0